import {k} from 'src/environments/properties';

export class MyUtils {

    static getBaseLocation() {
        return `/admin`;
    }

    static remove(page: JfPageResponse<any>, element: any): void {
        const indexToRemove: number = page.content.indexOf(element);
        page.content = page.content.filter((val, i) => i !== indexToRemove);
        page.totalElements = page.totalElements - 1;
    }

    static getErrors(errorObj: any) {
        const br = '\n';
        if (errorObj.status === 401) {
            MyUtils.go2login();
        }
        let errorStr = '';
        if (typeof errorObj === 'string') {
            errorStr = errorObj;
        }
        if (errorObj.error) {
            if (typeof errorObj.error === 'string') {
                errorStr += errorObj.error + br;
            }
            if (errorObj.error.message) {
                errorStr += errorObj.error.message + br;
            }
            if (errorObj.error.errors) {
                const erValues = Object.keys(errorObj.error.errors).map(itm => errorObj.error.errors[itm]);
                erValues.forEach((e1: string[]) => {
                    errorStr += `${br} · ${e1.join('${br} # ')}`;
                });
            }
        }
        return errorStr;
    }

    static go2login(timeout: number = 4000) {
        setTimeout(() => {
            MyUtils.clearEnvironment();
            const newLocal = MyUtils.getBaseLocation();
            window.location.href = newLocal + '/login';
        }, timeout);
    }

    static clearEnvironment() {
        localStorage.removeItem(k.userInformation);
        localStorage.removeItem(k.user_id);
        localStorage.removeItem(k.user_role_id);
        localStorage.removeItem(k.permissions);
        localStorage.removeItem(k.adm_token);
        localStorage.removeItem(k.token);
        document.cookie = "access_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure; samesite=strict;";
    }

    static downloadFile(data: any, name: string, type: string = 'csv') {
        
        
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = name + '.' + type;
        link.click();
        

    }

    static onGetExtensionFile(title: string): string {
        let fileExtension = 'ico-pdf.png';
        if (title !== null) {
            const strSplit = title.split('.');
            const extensionFile = strSplit[strSplit.length-1];
            switch (extensionFile) {
                case 'pdf':
                    fileExtension = 'ico-pdf.png';
                    break;
                case 'doc':
                    fileExtension = 'ico-docx.png';
                    break;
                case 'docx':
                    fileExtension = 'ico-docx.png';
                    break;
                case 'xls':
                    fileExtension = 'ico-xlsx.png';
                    break;
                case 'xlsx':
                    fileExtension = 'ico-xlsx.png';
                    break;
                case 'ppt':
                    fileExtension = 'ico-pptx.png';
                    break;
                case 'pptx':
                    fileExtension = 'ico-pptx.png';
                    break;
                case 'jpg':
                    fileExtension = 'ico-jpg.png';
                    break;
                case 'jpeg':
                    fileExtension = 'ico-jpg.png';
                    break;
                case 'png':
                    fileExtension = 'ico-png.png';
                    break;
                case 'gif':
                    fileExtension = 'ico-gif.png';
                    break;
                default:
                    fileExtension = 'ico-pdf.png';
                    break;
            }
        } else {
            fileExtension = 'ico-mov.png';
        }
        return  fileExtension;
    }


    static  sanitizerTitulo (titulo: string) {
        let slug = "";
        // Change to lower case
        let titleLower = titulo != null ? titulo.toLowerCase() : '';
        // Letter "e"
        slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
        // Letter "a"
        slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
        // Letter "o"
        slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
        // Letter "u"
        slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
        // Letter "d"
        slug = slug.replace(/đ/gi, 'd');
        // Trim the last whitespace
        slug = slug.replace(/\s*$/g, '');
        // Change whitespace to "-"
        slug = slug.replace(/\s+/g, '-');

        return slug;
    }


}

export class JfPageResponse<E> {
    constructor(
        public totalPages: number,
        public totalElements: number,
        public content: E[],
        public message?: string,
        public hasPrevPage?: boolean,
        public hasNextPage?: boolean) {
    }
}

export class JfLazyLoadEvent {
    constructor(
        public rows: number = 10,
        public first: number = 1,
        public multiSortMeta?: JfSort[],
        public conditions?: any[],
        public joins?: JfCondition[],
        public additional?: JfCondition[],
        public includes?: any[],
        public select?: string[]) {
    }
}

export class JfCondition {
    constructor(
        public condition: string,
        public value?: any) {
    }
}

export class JfSort {
    static desc = -1;
    static asc = 1;

    constructor(
        public field: string,
        public order: number = -1) {
    }
}

